import {
  AppBar,
  Box,
  Container,
  ContainerProps,
  Link,
  Toolbar,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import * as React from 'react';

const useStyles = makeStyles((theme) => ({
  appBar: {
    background: theme.palette.primary.dark,
    color: theme.palette.primary.contrastText,
    zIndex: 100
  }
}));

export interface FooterProps {
  leftContent?: React.ReactNode;
  rightContent?: React.ReactNode;
  containerWidth?: ContainerProps['maxWidth'];
}

const Footer: React.FC<FooterProps> = ({
  leftContent,
  rightContent,
  containerWidth
}) => {
  const classes = useStyles();

  return (
    <AppBar component="footer" position="relative" className={classes.appBar}>
      <Toolbar disableGutters>
        <Container
          component="main"
          maxWidth={containerWidth}
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
          }}
        >
          {leftContent && <Box flex="0 0 auto">{leftContent}</Box>}
          <Box flex="1 1 0%">
            <Typography
              variant="body2"
              color="inherit"
              align="center"
              display="block"
            >
              {'© '}
              <Link
                href="https://awbd-tx.org"
                style={{
                  color: 'inherit',
                  fontWeight: 'inherit',
                  textDecoration: 'none'
                }}
              >
                {new Date().getFullYear()} Association of Water Board Directors
                - Texas
              </Link>
            </Typography>
          </Box>
          {rightContent && <Box flex="0 0 auto">{rightContent}</Box>}
        </Container>
      </Toolbar>
    </AppBar>
  );
};

export default Footer;
